import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "@/constants/brand";

export default function Footer() {
    return (
        <footer
            data-testid="footer"
            className="bg-forest-900 text-cream py-10 border-t border-gold-500/20"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                    <img
                        src={LOGO_URL}
                        alt="Resham Drops"
                        className="w-10 h-10 rounded-full border border-gold-500/60 object-cover"
                    />
                    <div>
                        <div className="font-serif font-bold text-gold-400 text-lg leading-tight">
                            Resham Drops
                        </div>
                        <div className="text-[10px] uppercase tracking-[0.2em] text-cream/70">
                            Botanical hair science · Pakistan
                        </div>
                    </div>
                </div>
                <nav data-testid="footer-links" className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-cream/80">
                    <Link to="/shop" className="hover:text-gold-400">Shop</Link>
                    <Link to="/product/dermalist-rosemary-hair-growth-serum" className="hover:text-gold-400">Rosemary Hair Serum</Link>
                    <Link to="/product/crystal-serum-applicator-scalp-massager-comb" className="hover:text-gold-400">Scalp Massager Comb</Link>
                    <Link to="/hair-care-guide" className="hover:text-gold-400">Hair Fall Guide</Link>
                    <Link to="/ur/hair-care-guide" className="hover:text-gold-400 font-urdu" style={{ letterSpacing: 0 }}>بال گرنے کا علاج</Link>
                    <Link to="/blog" className="hover:text-gold-400">Blog</Link>
                    <Link to="/ur/blog" className="hover:text-gold-400 font-urdu" style={{ letterSpacing: 0 }}>اردو بلاگ</Link>
                    <Link to="/track-order" className="hover:text-gold-400">Track Order</Link>
                </nav>
                <p className="text-xs text-cream/70">
                    © {new Date().getFullYear()} Resham Drops. All rights
                    reserved. PCSIR Certified.
                </p>
            </div>
        </footer>
    );
}
